import * as client_hooks from '../../../src/hooks.client.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/about": [3],
		"/brand": [4],
		"/careers": [5],
		"/changelog": [~6],
		"/changelog/[entryDate]": [~7],
		"/compliance": [8],
		"/compliance/gdpr": [9],
		"/compliance/hipaa": [10],
		"/compliance/hitrust-csf": [11],
		"/compliance/iso-27001": [12],
		"/compliance/soc-2": [13],
		"/contact": [14],
		"/customers": [15],
		"/download": [16],
		"/dpa": [17],
		"/features": [18],
		"/integrations": [19],
		"/mobile": [20],
		"/pricing": [21],
		"/privacy": [22],
		"/refunds": [23],
		"/roadmap": [24],
		"/terms": [25]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';